import { FONT, getFont } from '@tornado-rdk/typography';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../utils/style';
import { getLabelFont, PADDING } from '../stamp/stamp.style';

export const defaultContext = makeDefaultStylingContext();

export const GAP = {
  [HD]: 4,
  [FULL_HD]: 4,
};

export const HEIGHT = {
  [HD]: getLabelFont(HD).lineHeight + PADDING[HD] * 2,
  [FULL_HD]: getLabelFont(FULL_HD).lineHeight + PADDING[FULL_HD] * 2,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const getTextTemplate = screenSize => ({
  ...getFont(FONT.BOSTON_2, screenSize),
  verticalAlign: 'middle',
  wordWrap: false,
  textOverflow: '...',
});

export const getInitialStyle = ({ screenSize } = defaultContext) => ({ h: HEIGHT[screenSize] });
